/******************************************************************************
 *
 * RuntimeChecklistItems
 *
 * Loads and displays runtime checklist items for a runtime checklist.
 *
 ******************************************************************************/

import React, { useEffect, useState } from "react";
import wmsWorkService from "../../../services/wmsWorkService";
import RuntimeChecklistItem from "./RuntimeChecklistItem";

export default function RuntimeChecklistItems({
    workChecklistId
}) {

    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    useEffect(() => {

        async function load() {

            try {

                setLoading(true);

                const data =
                    await wmsWorkService.getWorkChecklistItems(
                        workChecklistId
                    );

                console.log(
                    "Runtime Checklist Items",
                    data
                );

                setItems(data || []);

            }

            catch (err) {

                console.error(err);

                setItems([]);

            }

            finally {

                setLoading(false);

            }

        }

        if (workChecklistId) {

            load();

        }
        else {

            setItems([]);
            setLoading(false);

        }

    }, [workChecklistId]);

    if (loading) {

        return (

            <div className="text-muted">

                Loading...

            </div>

        );

    }

    if (items.length === 0) {

        return (

            <div className="text-muted">

                No checklist items.

            </div>

        );

    }

    return (

        <div>

            {items.map((item) => (

                <RuntimeChecklistItem
                    key={item.id}
                    item={item}
                />

            ))}

        </div>

    );

}